// @flow
import * as Immutable from 'immutable'; // This is required

import { Color } from 'common/models/flow/Color';
import type { ColorModelType } from 'common/models/flow/Color';

class InternalColor extends Color {
    static fromJS(json: ColorModelType): InternalColor {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    getClassName({ theme, prefix, suffix = 'Color' }) {
        return theme[`${prefix}${this.name}${suffix}`];
    }
}

export { InternalColor as Color };
